import Tooltip from '~/src/common/components/Tooltip/Tooltip';
import { ImageParams } from '~/src/common/typings/image';
import { getImageUrlFromFormat } from '~/src/common/utils/cloudinary';
import type { getProductLabelImages } from '~/src/common/utils/product';

import styles from './ProductLabels.module.scss';

interface Props {
  labels: ReturnType<typeof getProductLabelImages>;
}

export const ProductLabels = (props: Props) => {
  return (
    <div className={styles.productLabels}>
      {props.labels.map(({ id, label, image }) => (
        <Tooltip key={id} content={label}>
          <img
            className={styles.productLabel}
            src={getImageUrlFromFormat(image, 'square', ImageParams.productBigLabels)}
            alt={label}
          />
        </Tooltip>
      ))}
    </div>
  );
};
